import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.set";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.set";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";

var EventBus = /*#__PURE__*/function () {
  function EventBus() {
    this.subscribers = new Map();
  }

  var _proto = EventBus.prototype;

  _proto.subscribe = function subscribe(type, handler) {
    if (!this.subscribers.has(type)) {
      this.subscribers.set(type, new Set());
    }

    var handlers = this.subscribers.get(type);
    handlers.add(handler);
    return function () {
      handlers["delete"](handler);
    };
  };

  _proto.dispatch = function dispatch(type) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var handlers = this.subscribers.get(type);

    if (handlers) {
      // handler needed a type assertion to fix type bug
      handlers.forEach(function (handler) {
        handler.apply(void 0, args);
      });
    }
  };

  return EventBus;
}();

export { EventBus as default };